import React, { useEffect, useState } from 'react'
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as bie from "react-bootstrap";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FiCheckCircle, FiXCircle } from "react-icons/fi";
export default function NOCCollegeCompletionPerReport() {

    const [status, setStatus] = useState([]);
    const [isFetched, setIsFetched] = useState(false);
    function GetStatus(noctype) {
        if (!noctype) {
            setIsFetched(false);
            return
        }
        setIsFetched(false);
        CommonAxiosGet(`${config.url.FAC_URL}getNocStatusReport?nocType=${noctype}`)
            .then((res) => {
                const data = res?.data?.scode === "01" ? res?.data?.data || [] : [];
                setStatus(data);
                setIsFetched(true); // mark API completed
            })
            .catch(() => {
                setStatus([]);
                setIsFetched(true);
            });
    }




    const renderStatus = (value) => {
        const isYes = ["yes", "true", "1"].includes(String(value).toLowerCase());

        return isYes ? (
            <FiCheckCircle color="#28a745" size={18} title="Yes" />
        ) : (
            <FiXCircle color="#dc3545" size={18} title="No" />
        );
    };

    const getYesCount = (key) => {
        return status?.filter(item => item[key] === "Yes").length;
    };
    const StatusColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,

        },
        {
            id: "coll_code",
            header: "College Code",
            accessorKey: "coll_code",
        },
        {
            id: "inst_name",
            header: "Institute Name",
            accessorKey: "inst_name",
            Footer: "Total",

        },
        {
            id: "inst_details",
            header: "Institute Details",
            accessorKey: "inst_details",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("inst_details"),

        },
        {
            id: "course_intake_details",
            header: "Course / Intake",
            accessorKey: "course_intake_details",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("course_intake_details"),
        },
        {
            id: "infrastructure",
            header: "Infrastructure",
            accessorKey: "infrastructure",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("infrastructure"),
        },
        {
            id: "staff_details",
            header: "Staff Details",
            accessorKey: "staff_details",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("staff_details"),
        },
        {
            id: "courpus_fund",
            header: "Corpus Fund",
            accessorKey: "courpus_fund",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("courpus_fund"),
        },
        {
            id: "application_details",
            header: "Application Details",
            accessorKey: "application_details",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("application_details"),
        },
        {
            id: "upload_doc",
            header: "Upload Documents",
            accessorKey: "upload_doc",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("upload_doc"),
        },
        {
            id: "payment_details",
            header: "Payment Details",
            accessorKey: "payment_details",
            cell: ({ getValue }) => renderStatus(getValue()),
            Footer: () => getYesCount("payment_details"),

        },
    ];

    const InstitutionFormik = useFormik({
        initialValues: {
            nocType: "",

        },
        // validationSchema,
        enableReinitialize: true,
        onSubmit: (val) => {
            console.log("val", val)
        },
    });

    const NOC_TYPE_MAP = {
        // "Merger of Institutions": "merge_ofinstructions",
        // "Conversion of the Institution": "type_converstions",
        // "Closure of Institution": "closure_of_institutions",
        // "Trust / Society Name Change": "society_name_change",
        // "Programme / Intake Changes": "intake_changes",
        "Shifting of the Institution": "shifting",
        // "Change of Institution Name": "change_of_inst_name",
        "Extension of Permission (EoP)": "eop",
        "Management Change": "management"
    };

    return (


        <div className="faculty-form-wrapper">
            <div className="faculty-card">

                <h5 className="mb-3 innerheader-new">
                    <span>NOC Status Report</span>
                </h5>
                <FormikProvider value={InstitutionFormik}>
                    <Form className="form_adjust" onSubmit={InstitutionFormik.handleSubmit} onChange={InstitutionFormik.handleChange}>
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-2">
                                <label>Select NOC Type</label>
                                <Field
                                    as="select"
                                    name="nocType"
                                    className="form-control"
                                    onChange={(e) => {
                                        InstitutionFormik.handleChange(e);
                                        GetStatus(e.target.value);
                                    }}>
                                    <option value="">--Select--</option>

                                    {Object?.entries(NOC_TYPE_MAP)?.map(([label, value]) => (
                                        <option key={value} value={value}>
                                            {label}
                                        </option>
                                    ))}


                                </Field>


                                <ErrorMessage name="nocType" component="div" className="text-danger" />
                            </bie.Col>
                        </bie.Row>


                        {!isFetched ? null : status.length > 0 ? (
                            <div className="table-responsive">
                                <CommonReactTable
                                    data={status}
                                    columns={StatusColumns}
                                    filename="NOC STATUS REPORT"
                                    headerName="NOC STATUS REPORT"
                                    showFooter={true}
                                    showPagination={false}
                                    showExcel={true}
                                    showPrint={true}
                                    excelFileName="NOC Status Report"
                                />
                            </div>
                        ) : (
                            <center className="text-danger mt-4 h5">
                                ** No Data Found **
                            </center>
                        )}
                    </Form>
                </FormikProvider>
            </div>
        </div >

    )
}
